import React from 'react'
import banner from '../Images/Banner/Mobile_Computer.jpg';
import {ImHome} from 'react-icons/im';
import Mcomputer from '../Images/Products/MC2200.png';
import Mcomputer1 from '../Images/Products/MC33XX.png';
import Mcomputer2 from '../Images/Products/MC9300.png';
import Mcomputer3 from '../Images/Products/TC21.png';
import Mcomputer4 from '../Images/Products/TC53.png';
import Mcomputer5 from '../Images/Products/TC72.png';
import Footer from '../Footer';
import MC2200 from '../Documents/MC2200_MC2700-Specification.pdf';
import MC3300 from '../Documents/MC3300AX-Specification.pdf';
import MC9300 from '../Documents/MC9300-Specification.pdf';
import TC21 from '../Documents/TC21_TC26-Specification.pdf';
import TC53 from '../Documents/TC53_TC58-Specification.pdf';
import TC72 from '../Documents/TC72_TC77-Specification.pdf';
import ScrollButton from '../Home/Scrollbutton';

const Mobilecomputer = () => {
  window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
  return (
    <>
    <div className='container'>
      <div className="mb-0 bg-light">
          <img src ={banner} alt="RFID-slide" className='img-fluid'/> 
          <div className='d-flex p-1'>
            <ImHome className='m-1'/>
            <nav aria-label="breadcrumb">
              <ul className="breadcrumb">
                <li className="breadcrumb-item ms-1"> <a href="/">Home</a></li>
                <li className="breadcrumb-item ms-1"> <a href="/product">Products</a></li>
                <li className="breadcrumb-item active" aria-current="page">Mobilecomputer</li>
              </ul>
            </nav>
          </div>
        
      </div>
    </div>
    <div className='container'>
      <div className='Prod-head-title fw-bold mt-5'><h1>TYPES OF RFID MOBILECOMPUTER</h1>
        <h5 className='mt-4'>Searching for The Right Mobile Computer</h5>
      </div>
    </div>
      <div className='container'>
        <div className="row row-cols-1 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 g-3">
            <div className='col '>
              <div className='card'>
                <div className='card-body card-prod'>
                <h5 className="card-title m-1 m-sm-0 fs-2 fs-sm-5 fw-bold">MC2200 AND MC2700</h5>
                  <img src={Mcomputer} alt='Rfid-Reader' className='img-fluid'/>
                  <div className="overlay">
                    
                    <div className='download-cat'>
                      <a href={MC2200} target='blank' >Download Spec</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='col '>
              <div className='card'>
                <div className='card-body card-prod'>
                <h5 className="card-title m-1 m-sm-0 fs-2 fs-sm-5 fw-bold">MC3300AX</h5>
                  <img src={Mcomputer1} alt='Rfid-Reader' className='img-fluid'/>
                  <div className="overlay">
                    
                    <div className='download-cat'>
                      <a href={MC3300} target='blank' >Download Spec</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='col '>
              <div className='card'>
                <div className='card-body card-prod'>
                <h5 className="card-title m-1 m-sm-0 fs-2 fs-sm-5 fw-bold">MC9300</h5>
                  <img src={Mcomputer2} alt='Rfid-Reader' className='img-fluid'/>
                  <div className="overlay">
                    
                    <div className='download-cat'>
                      <a href={MC9300} target='blank' >Download Spec</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='col '>
              <div className='card'>
                <div className='card-body card-prod'>
                <h5 className="card-title m-1 m-sm-0 fs-2 fs-sm-5 fw-bold">TC21 AND TC26</h5>
                  <img src={Mcomputer3} alt='Rfid-Reader' className='img-fluid'/>
                  <div className="overlay">
                    
                    <div className='download-cat'>
                      <a href={TC21} target='blank' >Download Spec</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='col '>
              <div className='card'>
                <div className='card-body card-prod'>
                <h5 className="card-title m-1 m-sm-0 fs-2 fs-sm-5 fw-bold">TC53 AND TC58</h5>
                  <img src={Mcomputer4} alt='Rfid-Reader' className='img-fluid'/>
                  <div className="overlay">
                    
                    <div className='download-cat'>
                      <a href={TC53} target='blank' >Download Spec</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='col '>
              <div className='card'>
                <div className='card-body card-prod'>
                <h5 className="card-title m-1 m-sm-0 fs-2 fs-sm-5 fw-bold">TC72 AND TC77</h5>
                  <img src={Mcomputer5} alt='Rfid-Reader' className='img-fluid'/>
                  <div className="overlay">
                    
                    <div className='download-cat'>
                      <a href={TC72} target='blank' >Download Spec</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

        </div> 
      </div>  
        <br/>
        <br/>
        <br/>
        <div className='container'>
      <div className='why-bg img-fluid'>
        <h1 className=' container d-inline-block text-center text-white fw-bold pt-5'>WHY CHOOSE RSPM MOBILECOMPUTER</h1>
        <div className=" row row-cols-1 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 m-5 g-5">
          <div className='col'>
            <div className='RFID-card'>
              <div className='p-4'>
                <div className='RFID-num fw-bold '>01</div>
                <div className='RFID-Content mt-5'>
                 <h3 className='mt-3 fw-bold'>Globally applying</h3>
                 <p className='mt-3'>ISO18000-6B/6C and EPC Global UHF Class 1 Gen 2.</p>
                </div>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className='RFID-card mt-5'>
              <div className='p-4'>
                <div className='RFID-num fw-bold '>02</div>
                <div className='RFID-Content mt-5'>
                 <h3 className='mt-3 fw-bold'>Excellent performance</h3>
                 <p className='mt-3'>High speed and accurancy in a long reading distance. Remarkable multiple reading and stable reading performance in variety of surrounding.</p>
                 
                </div>
              </div>
            </div>
          </div>
          <div className='col'>
            <div className='RFID-card'>
              <div className='p-4'>
                <div className='RFID-num fw-bold '>03</div>
                <div className='RFID-Content mt-5'>
                 <h3 className='mt-3 fw-bold'>Rugged and durable</h3>
                 <p className='mt-3'>Premium design and workmanship can used in harsh environment.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div> 
    <br/>  
        
      <ScrollButton/>
      <Footer/>
    </>
  )
}

export default Mobilecomputer